/**
 * @packageDocumentation
 * @module HackerAPI.User.AddressList
 */
import { __extends } from "tslib";
import Address from "../../address/address";
import Base from "../../base/base";
/**
 * A container for various type of addresses that a user can have
 * @class
 * @extends { HackerAPI.Base }
 */
var AddressList = /** @class */ (function (_super) {
    __extends(AddressList, _super);
    /**
     * Creates a new AddressList instance
     * @constructor
     * @param addressList
     */
    function AddressList(_a) {
        var mailing = _a.mailing, shipping = _a.shipping;
        var _this = _super.call(this) || this;
        /**
         * The user's mailing address
         * @type { HackerAPI.Address }
         */
        _this.mailing = (mailing && new Address(mailing)) || null;
        /**
         * The user's shipping address
         * @type { HackerAPI.Address }
         */
        _this.shipping = (shipping && new Address(shipping)) || null;
        return _this;
    }
    return AddressList;
}(Base));
export default AddressList;
//# sourceMappingURL=address-list.js.map